// AdminEmailJobTable component styles
export const tableComponentStyles = {
	mainContainer: {
		backgroundColor: 'white',
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		borderRadius: '8px',
		boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
	},
	headerContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		mb: 2,
	},
	filtersContainer: {
		display: 'flex',
		gap: 2,
	},
	dataGridContainer: {
		width: '100%',
	},
};

// DataGrid styles
export const dataGridStyles = {
	'--DataGrid-containerBackground': 'white',
	'& .capitalize-text': {
		textTransform: 'capitalize',
	},
	'& .MuiDataGrid-columnHeader': {
		backgroundColor: 'white',
	},
	'& .MuiDataGrid-columnHeaderTitle': {
		fontWeight: 600,
	},
	'& .MuiDataGrid-row': {
		backgroundColor: 'white !important',

		'&:hover': {
			backgroundColor: '#f8f8f8 !important',
		},
	},
	'& .MuiDataGrid-row--even': {
		backgroundColor: 'white !important',
	},
	'& .MuiDataGrid-row--odd': {
		backgroundColor: 'white !important',
	},
	'& .MuiDataGrid-cell': {
		backgroundColor: 'transparent',
	},
	border: '1px solid #f8f8f8',
	borderRadius: 0,
	'& .MuiDataGrid-footerContainer': {
		borderTop: '1px solid #f8f8f8',
		backgroundColor: 'white',
		minHeight: '52px',
	},
};
